import React from 'react';
import './courseTag.scss';
import { supportUMUAndNewTag } from '../../utils/intelligentCourse';

export function CourseTag({ tag }: { tag?: string }) {
    return tag && supportUMUAndNewTag ? <div className="course-label-tag">{tag}</div> : null;
}
